/* stylelint-disable selector-class-pattern */

.modal {
  min-width: 90vw;

  :global {
    .ant-modal-body {
      padding: 16px 24px;
    }

    .ant-tabs-nav-list {
      text-transform: capitalize;
    }
  }
}

.rowPreviewBig {
  position: relative;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--x-color-border);

  :global {
    .anticon.anticon-warning svg {
      font-size: 150px;
    }
  }
}

.divider {
  width: 1px;
  height: 100%;
  border-right: 1px solid var(--x-color-border);
  margin: auto;
}

.bucketName {
  background-color: var(--x-color-background);
}

.imgPreviewBig {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}

.empty {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pdfViewerWrapper {
  :global {
    .pdf-viewer {
      min-height: 80vh;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
    }
  }
}

.scsViewerWrapper {
  width: 100%;
  height: 100%;
}

.bucketFilename {
  margin-top: 5px;
  word-break: break-all;
}

.active {
  color: var(--x-color-action);
}
